import { Language } from "./constants";
import { isNumberValue, isStringValue } from "./helpers";

export const getDecimalSeparator = (language: Language): string => (language === Language.fr ? "," : ".");
export const getThousandSeparator = (language: Language): string => (language === Language.fr ? " " : ",");

export const toFormattedNumberStr = (
  value: number, language: Language, decimalScale?: number, fixedDecimalScale?: boolean
): string => {

  if (!isNumberValue(value)) {
    return "";
  }

  decimalScale = isNumberValue(decimalScale) ? decimalScale : 0;
  const base = 10;
  const scale = Math.pow(base, decimalScale);

  let val =
    decimalScale == null
      ? value.toString()
      : decimalScale > 0
        ? (Math.round((value + Number.EPSILON) * scale) / scale).toString()
        : decimalScale === 0
          ? Math.round(value).toString()
          : value.toString();

  if (isNumberValue(decimalScale) && decimalScale > 0 && fixedDecimalScale === true) {
    const [w, d] = val.split(".");

    if ((d?.length || 0) < decimalScale) {
      val = `${w}.${(d || "").padEnd(decimalScale, "0")}`;
    }
  }

  val = language === Language.fr
    ? val.replace(".", ",")
    : val;

  const thousandSeparator = language === Language.fr ? "\u00A0" : ","; // unbreakable space for FR and comma for EN/rest
  const result = val.replaceAll(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);

  return result;
};

export const toUnformattedNumberStr = (value: string, language: Language): string => {

  if (!isStringValue(value)) {
    return "";
  }

  const result = language === Language.fr
    ? value.replaceAll(/[^\d,]/g, "").replace(",", ".")
    : value.replaceAll(/[^\d.]/g, "");

  return result;
};

export const toNumber = (value: string, language: Language): number | null => {

  const val = toUnformattedNumberStr(value, language);
  let result: number | null = val == null || val.trim() === "" ? null : Number(val);

  if (!isNumberValue(result)) {
    result = null;
  }

  return result;
};

